export const PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD = 2000;
export const PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD = 3000;
export const DEFAULT_SAMPLING_RATE_VALID_TRANSACTIONS = 100;